import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, NEHR_ACCESS_HISTORY_PATH, PUBLIC_HEALTHCARE_CLUSTERS_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const NehrAccessHistoryPage = lazy(
  () => import('@features/ConsentAndPermission/NehrAccessHistory/pages/NehrAccessHistoryPage')
);
const PublicHealthcareClusterPage = lazy(
  () => import('@features/ConsentAndPermission/NehrAccessHistory/pages/PublicHealthcareClusterPage')
);

export const NEHR_ACCESS_HISTORY_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <NehrAccessHistoryPage />,
    displayTitle: () => 'NEHR Access History',
    pageType: PageType.PRIVATE,
    path: NEHR_ACCESS_HISTORY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.nehrAccessHistory,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <PublicHealthcareClusterPage />,
    displayTitle: () => 'Public Healthcare Clusters',
    pageType: PageType.PRIVATE,
    path: PUBLIC_HEALTHCARE_CLUSTERS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.nehrAccessHistory,
  },
];
